const matchesFuzzy = (source, query) => {
  const normalizedSource = String(source ?? '').trim().toLowerCase();
  const normalizedQuery = String(query ?? '').trim().toLowerCase();

  if (!normalizedQuery) return true;
  if (normalizedSource.includes(normalizedQuery)) return true;

  let cursor = 0;
  for (const char of normalizedQuery) {
    cursor = normalizedSource.indexOf(char, cursor);
    if (cursor === -1) return false;
    cursor += 1;
  }

  return true;
};

const buildOptionsFromValues = (values, query) => {
  const seen = new Set();

  return (values ?? [])
    .filter((value) => {
      const normalized = String(value ?? '').trim();
      if (!normalized) return false;
      if (seen.has(normalized)) return false;
      seen.add(normalized);
      return matchesFuzzy(normalized, query);
    })
    .slice(0, 8)
    .map((value) => ({
      value,
      label: value,
    }));
};

export const buildOrderFieldOptions = (orders, key, query) =>
  buildOptionsFromValues(
    (orders ?? []).map((order) => order?.[key]),
    query,
  );

export const buildCustomerCompanyOptions = (customers, orders, query) =>
  buildOptionsFromValues(
    [
      ...(customers ?? []).map((customer) => customer?.name),
      ...(orders ?? []).map((order) => order?.customerCompany),
    ],
    query,
  );

export const buildCustomerNameOptions = (users, orders, query) =>
  buildOptionsFromValues(
    [
      ...(users ?? []).map((user) => user?.name),
      ...(orders ?? []).map((order) => order?.customerName),
    ],
    query,
  );

export const findCustomerUserByName = (users, rawName, rawCustomerCompany) => {
  const name = String(rawName ?? '').trim();
  const customerCompany = String(rawCustomerCompany ?? '').trim();

  if (!name) {
    return undefined;
  }

  const matchingUsers = (users ?? []).filter(
    (user) => String(user?.name ?? '').trim() === name,
  );

  if (!customerCompany) {
    return matchingUsers[0];
  }

  return (
    matchingUsers.find(
      (user) => String(user?.customer?.name ?? '').trim() === customerCompany,
    ) ?? matchingUsers[0]
  );
};
